function fetchProductInfo(product_url, productSection, productInfoSection) {
  fetch(`${product_url}?sections=${productSection},${productInfoSection}`)
    .then((response) => response.json())
    .then((response) => {
      var productSectionHTML = new DOMParser().parseFromString(
        response[productSection],
        "text/html"
      );
      var productTabsHTML = new DOMParser().parseFromString(
        response[productInfoSection],
        "text/html"
      );

      $(productSectionHTML).find(".priority_shipping_container").hide();
      $("#quick-view").html(
        productSectionHTML.querySelector('[data-section-type="product"]')
      );

      $(productTabsHTML)
        .find(".mobile_info_wrapper")
        .insertAfter($("#quick-view").find(".product-form__buy-buttons"));

      $("#quick-view")
        .find(".block-swatch:first-child > .variant-click")
        .addClass("active");
      $("#quick-view").find(".main-product-description").removeClass("hide");
      $("html").addClass("quick-view-shown");
    });

  $.fancybox({
    href: "#quick-view",
    maxWidth: 1152,
    maxHeight: 800,
    fitToView: true,
    width: "75%",
    height: "70%",
    autoSize: false,
    closeClick: false,
    openEffect: "none",
    closeEffect: "none",
    beforeLoad: function () {
      $(".fancybox-wrap").css("overflow", "hidden !important");
    },
    afterShow: function () {},
    afterClose: function () {
      $("#quick-view").removeClass().empty();
      $("html").removeClass("quick-view-shown");
    },
  });
}
$(document).on("click", ".quick-view", function () {
  if ($("#quick-view").length == 0) {
    $("body").append('<div id="quick-view"></div>');
  }

  var product_url = $(this).data("url");
  var productMainSectionId =
    $(".main-product-section").data("section-id") ||
    window.localStorage.getItem("productMainSectionId");
  var infoTabSectionid =
    $(".product-info-tabs").data("section-id") ||
    window.localStorage.getItem("infoTabSectionid");

  if (!productMainSectionId || !infoTabSectionid) {
    fetch(`${product_url}`)
      .then((response) => response.text())
      .then((response) => {
        let $product = $(response);
        let productMainSectionId = $product
          .find(".main-product-section")
          .data("section-id");
        let infoTabSectionid = $product
          .find(".product-info-tabs")
          .data("section-id");

        window.localStorage.setItem(
          "productMainSectionId",
          productMainSectionId
        );
        window.localStorage.setItem("infoTabSectionid", infoTabSectionid);
        fetchProductInfo(product_url, productMainSectionId, infoTabSectionid);
      });
  } else {
    fetchProductInfo(product_url, productMainSectionId, infoTabSectionid);
  }
});
